import React from 'react';
import { motion } from 'framer-motion';

const STEPS = [
  { name: 'Discover', desc: 'Deep workshop. We map your business, audience, and constraints.' },
  { name: 'Strategy', desc: 'A measurable plan — KPIs, scope, milestones — agreed in writing.' },
  { name: 'Design', desc: 'Brand-true visual systems, user flows, and prototypes you can feel.' },
  { name: 'Build', desc: 'Production engineering on modern stacks. Daily commits. Daily clarity.' },
  { name: 'Launch', desc: 'Tested, monitored, instrumented. We ship, then we measure.' },
  { name: 'Scale', desc: 'Ongoing optimization, automation, and growth — month over month.' },
];

export const Process = () => {
  return (
    <section id="process" data-testid="process-section" className="relative py-24 lg:py-40 px-6 lg:px-12 border-t border-white/10 bg-brand-surface/30">
      <div className="max-w-[1400px] mx-auto grid lg:grid-cols-12 gap-12 lg:gap-20">
        {/* Sticky title */}
        <div className="lg:col-span-4">
          <div className="lg:sticky lg:top-32">
            <div className="flex items-center gap-3 mb-6">
              <span className="w-1.5 h-1.5 bg-brand-primary" />
              <span className="font-manrope text-xs uppercase tracking-[0.3em] text-white/60">
                03 — Process
              </span>
            </div>
            <h2 className="font-outfit font-black tracking-tighter text-white text-5xl lg:text-7xl leading-[0.85]">
              How we<br />operate.
            </h2>
            <p className="mt-8 font-manrope text-white/60 leading-relaxed max-w-md">
              Six steps. Zero ambiguity. Each phase has explicit deliverables, owners, and exit criteria.
            </p>
          </div>
        </div>

        {/* Timeline */}
        <div className="lg:col-span-8 relative">
          <div className="absolute left-4 top-2 bottom-2 w-px bg-gradient-to-b from-brand-primary/40 via-white/10 to-transparent" />
          <div className="flex flex-col gap-10">
            {STEPS.map((s, i) => (
              <motion.div
                key={s.name}
                initial={{ opacity: 0, x: 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, margin: '-50px' }}
                transition={{ duration: 0.5, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
                data-testid={`process-step-${i}`}
                className="relative pl-16"
              >
                <div className="absolute left-0 top-1 w-9 h-9 flex items-center justify-center bg-brand-bg border border-brand-primary/50">
                  <span className="font-manrope text-xs text-brand-primary font-semibold">0{i + 1}</span>
                </div>
                <h3 className="font-outfit font-bold text-3xl lg:text-4xl text-white tracking-tight">
                  {s.name}
                </h3>
                <p className="mt-3 font-manrope text-base text-white/60 leading-relaxed max-w-2xl">
                  {s.desc}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
